import { useBundle } from "./useBundleService";

export const useBundlesWithProduct = (productId: string) => {
  const bundles = useBundle(state => state.bundles);

  const bundlesWithProduct = bundles.filter(bundle => {
    const peripheralMatch = bundle.bundledItems.find(item => item.catalogItem === productId);
    const mainDeviceMatch = bundle.mainDevice === productId;

    if (peripheralMatch || mainDeviceMatch) return true;
  });

  return bundlesWithProduct;
};
